import React from 'react'

import { Dialog } from 'primereact/dialog'

import CadastroContasAPagarService from '../../app/service/central/cadastroContasAPagarService'
import ConstantsUtil from '../../context/constantsUtil'
import * as popUp from '../toastr'
import HandleErrorService from '../../app/service/handleErrorService'
import DialogFooter from '../dialogFooter'
import AuthService from '../../app/service/authService'

class CreateOrUpdateTipoDreCompetenciaDialog extends React.Component {

    constructor(){
        super()
        this.cadastroContasAPagarService = new CadastroContasAPagarService()
    }

    state = {

        tipoDreCompetencia: {},
        inputErrorClass: '',

    }

    componentDidUpdate(){
        this.setStates()
    }

    setStates = () => {
        if( (this.props.visible && !this.state.didUpdated) || this.props.forceUpdate ){

            // console.log("setStates: ", this.props.tipoDreCompetencia)

            this.resetView()

            if(this.props.tipoDreCompetencia){
                this.setState({tipoDreCompetencia: this.props.tipoDreCompetencia})
                }
            else(
                this.setState({tipoDreCompetencia: {}})
            )

                
            this.setState({didUpdated: true})
            if(this.props.doneForceUpdate){
                this.props.doneForceUpdate()
            }
        }
    }

    resetView = () => {
        this.setState({inputErrorClass: ''})
    }

    handleChange = async event => {
        let tipoDreCompetencia = this.state.tipoDreCompetencia
        tipoDreCompetencia.descricao = event.target.value
        await this.setState({tipoDreCompetencia})
    }

    hideDialog = async () => {
        await this.setState({didUpdated: false})
        this.props.hideDialog()
    }

    checkData = () => {
        
        let check = true
        
        if(!this.state.tipoDreCompetencia || !this.state.tipoDreCompetencia.descricao){
            check = false
            this.setState({inputErrorClass: ConstantsUtil.bootstrapInputErrorClass})
        }

        return check

    }

    callSave = () => {
        this.resetView()
        if(this.checkData()){
            this.save()
        }
    }

    handleSave = () => {
        if(this.props.isEdit){
            return this.cadastroContasAPagarService.updateTipoDreCompetencia(this.state.tipoDreCompetencia)
        }
        else{
            return this.cadastroContasAPagarService.createTipoDreCompetencia(this.state.tipoDreCompetencia)
        }
    }

    save = () => {
        AuthService.startBlockUi()
        this.handleSave()
        .then(response => {
            this.hideDialog()
            popUp.successPopUp("Salvo com sucesso!")
            if(this.props.search){
                this.props.search()
            }
        })
        .catch(error => 
            HandleErrorService.handleError(error)
        )
        .finally(() => {
            AuthService.stopBlockUi()
        })
    }

    render(){

        const dialogFooter = (
            <DialogFooter save = {this.callSave} hideDialog = {this.hideDialog}/>
        )

        return(
            <>
                <Dialog
                    header={` ${this.props.isEdit ? 'Editar' : 'Criar'}  ${ConstantsUtil.tipoDreCompetenciaLabel}`}
                    visible={this.props.visible}
                    modal = {true}
                    style={{ width: '350px' }}
                    footer={dialogFooter}
                    onHide={this.hideDialog}
                >
                    <div className="p-field">
                        {/* <label>{GeneralServices.getTipoDeProdutoOuEstoqueLabel(this.props.tipo)}</label> */}
                        <label>{ConstantsUtil.tipoDreCompetenciaLabel}</label>
                        <input
                            type="text"
                            autoFocus
                            className={"form-control " + this.state.inputErrorClass}
                            value = {this.state.tipoDreCompetencia.descricao}
                            onChange={this.handleChange}
                        />    
                        <div className="invalid-feedback">{"Informe o nome"}</div>
                    </div>

                    <br />

                </Dialog>            
            </>
        )
    }

}

export default CreateOrUpdateTipoDreCompetenciaDialog